import { render, staticRenderFns } from "./RequestAdvisorAccess.vue?vue&type=template&id=08c2cff8"
import script from "./RequestAdvisorAccess.vue?vue&type=script&lang=js"
export * from "./RequestAdvisorAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports